import { translateRawRuntime } from "@/lib/i18n/rawTranslations";
import { ApiError, NotifyOptions } from "./type";

export function handleApiError(
  err: ApiError,
  notifyError: (args: { message: string; description: string }) => void,
  options: NotifyOptions = {}
) {
  const statusCode = err?.data?.statusCode || err?.status || "Unknown";
  const errorMessage =
    err?.data?.message ||
    options.fallbackMessage ||
    "Something went wrong. Please try again later.";

  notifyError({
    message: translateRawRuntime(options.title || `Error ${statusCode}`),
    description: translateRawRuntime(errorMessage),
  });
}
